module.exports = __webpack_public_path__ + "static/media/rexel-cover.bea4daa5.jpg";